module.exports = __webpack_public_path__ + "img/dark--active.c7819e87.svg";